import React from 'react'
import { Link } from 'react-router-dom'

import './Navbar.css'

import img1 from '../../Images/Home.webp'
import img2 from '../../Images/About.webp'
import img3 from '../../Images/Skill.webp'
import img4 from '../../Images/Project.webp'
import img5 from '../../Images/Contact.webp'

const Navbar = () => {
  return (
    <>


      <div className="bottom-bar">
        <Link to="/" data-toggle="tooltip" data-placement="top" title="Home">
          <img src={img1} />
        </Link>

        <Link to="/about">
          <img src={img2} data-toggle="tooltip" data-placement="top" title="About"/>
        </Link>

        <Link to="/skill">
          <img src={img3} data-toggle="tooltip" data-placement="top" title="Skills"/>
        </Link>

        <Link to="/project">
          <img src={img4} data-toggle="tooltip" data-placement="top" title="Project"/>
        </Link>

        <Link to="/contact">
          <img src={img5} data-toggle="tooltip" data-placement="top" title="Contact"/>
        </Link>
      </div>

      
    </>
  )
}

export default Navbar
